import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ChevronIcon } from "../chevronIcon";
import { getMonthsNames } from "../utils";
import { chunkMonths } from "./utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Months({ date, cursor, editCursor, switchViews, ...props }: Props) {
  const { t } = useTranslation();
  const minDate = props.minDate
    ? new Date(
        Date.UTC(props.minDate.year, props.minDate.month, props.minDate.day),
      )
    : new Date(0);
  const maxDate = props.maxDate
    ? new Date(
        Date.UTC(props.maxDate.year, props.maxDate.month, props.maxDate.day),
      )
    : new Date(99999, 1);

  return (
    <div className={styles.calendar}>
      <div className={styles.heading}>
        <div
          className={classNames(styles.iconBox, {
            [styles.disabledIconBox]:
              new Date(Date.UTC(cursor.getUTCFullYear(), 0)) <= minDate,
          })}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ year: cursor.getUTCFullYear() - 1 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.leftIcon)} />
        </div>
        <h3 className={styles.title} onClick={() => switchViews("years")}>
          {cursor.getUTCFullYear()}
        </h3>
        <div
          className={classNames(styles.iconBox, {
            [styles.disabledIconBox]:
              new Date(Date.UTC(cursor.getUTCFullYear(), 0)) > maxDate,
          })}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ year: cursor.getUTCFullYear() + 1 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.rightIcon)} />
        </div>
      </div>
      <ul className={styles.main}>
        {chunkMonths(getMonthsNames(t)).map((months, chunkIndex) => (
          <li key={chunkIndex} className={styles.months}>
            <ul className={styles.row}>
              {months.map((month: string, index) => (
                <li
                  key={month}
                  className={classNames(styles.month, {
                    [styles.selected]:
                      cursor.getUTCFullYear() === date.year &&
                      chunkIndex * 4 + index === date.month,
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    editCursor({ month: chunkIndex * 4 + index, day: 10 });
                    switchViews("days");
                  }}
                >
                  <p className={styles.name}>
                    {month.length > 4 ? `${month.slice(0, 3)}.` : month}
                  </p>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      {!!props.clear && !!props.today ? (
        <div className={styles.footer}>
          <div className={styles.clear} onClick={props.today}>
            <div className={styles.button}>
              <p>{t("calendar.today")}</p>
            </div>
          </div>
          <div className={styles.clear} onClick={props.clear}>
            <div className={styles.button}>
              <p>{t("calendar.clear")}</p>
            </div>
          </div>
        </div>
      ) : !!props.clear ? (
        <div className={styles.clear} onClick={props.clear}>
          <div className={styles.button}>
            <p>{t("calendar.clear")}</p>
          </div>
        </div>
      ) : (
        !!props.today && (
          <div className={styles.clear} onClick={props.today}>
            <div className={styles.button}>
              <p>{t("calendar.today")}</p>
            </div>
          </div>
        )
      )}
    </div>
  );
}

export { Months };
